import { useGlobal } from '@/utils/useGlobal';
import EfVideo from '@elem/ui/ef-video';
import { useState } from 'react';
import stylys from './index.module.scss';
import gtm from '@/utils/gtm';

interface ItemProps {
    sources: string;
    posters: string;
    tab: string;
    desc: any;
}

const Energize = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const [active, setActive] = useState(0);

    const items: ItemProps[] = [
        {
            sources: 'https://websiteoss.ecoflow.com/upload/video/1752047807437/Energize1.mp4',
            posters: 'https://websiteoss.ecoflow.com/upload/image/1749621812956/energize1.jpg',
            tab: t('energize_item_title1'),
            desc: 'energize_item_desc1',
        },
        {
            sources: 'https://websiteoss.ecoflow.com/upload/video/1751262626344/Energize2.mp4',
            posters: 'https://websiteoss.ecoflow.com/upload/image/1749621812815/energize2.jpg',
            tab: t('energize_item_title2'),
            desc: 'energize_item_desc2',
        },
        {
            sources: 'https://websiteoss.ecoflow.com/upload/video/1751262626105/Energize3.mp4',
            posters: 'https://websiteoss.ecoflow.com/upload/image/1749621812815/energize2.jpg',
            tab: t('energize_item_title3'),
            desc: 'energize_item_desc3',
        },
    ];

    const handleChangeTab = (e: MouseEvent, k: number) => {
        const target = e.target as HTMLElement;
        // h5 情况下切换 tab 需要显示出来
        if (window.innerWidth <= 768) {
            target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
        setActive(k);
        gtm.push({
            __btn_id1: stylys.energize,
            __btn_id2: items[k].tab,
        });
    };
    return (
        <section
            className={`${stylys.energize} OASIS-E GtmModuleData-section`}
            id="OASIS-E"
            data-section-id={stylys.energize}
            data-section-title={t(`energize_title`)}
        >
            <div className="info">
                <h2 className="title">{t('energize_title')}</h2>
                <p className="text">{t('energize_intro')}</p>
            </div>
            <div className="videos-container">
                <ul className="videos">
                    {items?.map((item: ItemProps, k: number) => (
                        <li className={`video video${k + 1} ${k === active ? 'active' : ''}`} key={item.desc}>
                            <EfVideo
                                className="video1"
                                pc={item.sources}
                                h5={item.sources}
                                poster={item.posters}
                                posterH5={item.posters}
                                loop={true}
                                autoPlay={true}
                            />
                        </li>
                    ))}
                </ul>
            </div>

            <ul className="tabs">
                {items?.map((item: ItemProps, k: number) => (
                    <li
                        className={`tab GtmModuleData-btn-text ${active === k ? 'active' : ''}`}
                        onClick={(e: MouseEvent) => handleChangeTab(e, k)}
                        key={item.tab}
                    >
                        <span className="tab-text">{item.tab}</span>
                    </li>
                ))}
                {/* <p className="line"></p> */}
            </ul>
            <p className="desc">
                {t.rich(items[active].desc, {
                    sup: (child: string) => <sup>{child}</sup>,
                })}
            </p>
        </section>
    );
};

export default Energize;
